import { parseFileResourceName } from '@/shared/utils/file-utils';

/**
 * Where an IDP extraction's source document can be loaded from, in order. A full
 * resource name is used as is. A bare file id is tried at the organization
 * level first, then in the current workspace, as the old preview did.
 *
 * @param documentName - A file resource name or a bare file id
 * @param organization - The current organization id
 * @param workspace - The current workspace id
 * @returns File resource names to try, in order
 */
export function getDocumentFileUrls(
  documentName: string,
  organization: string | undefined,
  workspace: string | undefined,
): string[] {
  if (parseFileResourceName(documentName)) return [documentName];
  if (!documentName || !organization) return [];
  return [
    `organizations/${organization}/files/${documentName}`,
    ...(workspace
      ? [
          `organizations/${organization}/workspaces/${workspace}/files/${documentName}`,
        ]
      : []),
  ];
}
